import React from 'react';
import styled from '@emotion/styled';

import AppStoreDownloadButton from '../../../../shared/images/app-store-download-button.svg';
import GooglePlayDownloadButton from '../../../../shared/images/google-play-download-button.svg';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../constants';

const AppDownloadButton = styled('a')`
  align-items: center;
  display: inline-flex;
  justify-content: center;
  width: 191px;

  img {
    height: 56px;
    width: auto;
  }
`;

const DownloadButtonsContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  width: 100%;

  & > a:first-of-type {
    justify-content: flex-end;
  }

  @media screen and (max-width: 445px) {
    margin-bottom: 24px;

    & > a:first-of-type {
      justify-content: center;
    }
  }
`;

const AppDownloadButtons = () => (
  <DownloadButtonsContainer>
    <AppDownloadButton href={APP_STORE_URL} target='_blank' rel='noopener noreferrer'>
      <img src={AppStoreDownloadButton} alt='Download on the App Store' />
    </AppDownloadButton>
    <AppDownloadButton href={GOOGLE_PLAY_URL} target='_blank' rel='noopener noreferrer'>
      <img src={GooglePlayDownloadButton} alt='Get it on Google Play' />
    </AppDownloadButton>
  </DownloadButtonsContainer>
);

export default AppDownloadButtons;
